import React, { useState } from "react";
import { FaTrashCan, FaPen, FaShare } from "react-icons/fa6";
import { IoCalendarOutline } from "react-icons/io5";
import { FaRegCalendarPlus, FaUserCircle } from "react-icons/fa";
import { RiVideoAddFill } from "react-icons/ri";
import { MdEmail, MdPhone, MdPayment } from 'react-icons/md';
import { useNavigate } from "react-router-dom";
import SharePopup from "../../../../PopUp/SocialSharePopup/SharePopup";
import AddServicePopup from "../AddServicePopup";
import { Modal } from "react-bootstrap";

const WebinarCard = ({ webinar, isAdmin, onDelete, onUpdate, communityId, username }) => {
  const [showAddWebinar, setShowAddWebinar] = useState(false);
  const [sharePopupOpen, setSharePopupOpen] = useState(false);
  const [socialUrl, setSocialUrl] = useState('');
  const [showUserDetails, setShowUserDetails] = useState(false);
  const navigate = useNavigate();

  const handleDelete = () => {
    if (window.confirm('Are you sure you want to delete this webinar?')) {
      onDelete(webinar._id);
    }
  };

  const handleOpenSocialShare = (e) => {
    e.stopPropagation();
    const webinarUrl = `${window.location.origin}/webinar/join-webinar/${username}/${webinar._id}`;
    setSocialUrl(webinarUrl);
    setSharePopupOpen(true);
  };

  const isWebinarPast = (startTime) => {
    const webinarDate = new Date(startTime);
    const currentDate = new Date();
    return webinarDate < currentDate;
  };

  const handleWebinarAction = (e) => {
    e.stopPropagation();
    const isPast = isWebinarPast(webinar.startTime);
    
    if (isPast) {
      return; // Do nothing if webinar is past
    }

    const webinarUrl = `/webinar/join-webinar/${username}/${webinar._id}`;
    
    // If user is the webinar creator, directly join
    if (isAdmin) {
      window.open(webinar.link, '_blank');
      return;
    }

    // If not creator, redirect to registration page
    navigate(webinarUrl);
  };

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", options);
  };

  return (
    <>
      <div className={`ch-event-card ${isWebinarPast(webinar.startTime) ? 'past-webinar' : ''}`}>
        {/* Admin Actions */}
        {isAdmin && (
          <div className="admin-actions" onClick={e => e.stopPropagation()}>
            <button 
              className="edit-button" 
              onClick={(e) => {
                e.stopPropagation();
                setShowAddWebinar(true);
              }}
            >
              <FaPen size={20} />
            </button>
            <button 
              className="delete-button" 
              onClick={(e) => {
                e.stopPropagation();
                handleDelete();
              }}
            >
              <FaTrashCan size={20} />
            </button>
          </div>
        )}

        {/* Share Button */}
      { 
        !isWebinarPast(webinar.startTime) &&  <div className="card-actions" onClick={e => e.stopPropagation()}>
          <button 
            className="share-button" 
            onClick={handleOpenSocialShare}
          >
            <FaShare size={20} />
          </button>
        </div>
        }

        <div className="ch-event-info">
          <h3>{webinar.title}</h3>
          <div className="ch-event-description" dangerouslySetInnerHTML={{ __html: webinar.description }} />

          <div className="ch-event-meta">
            <div className="ch-event-details">
              <span>
                <IoCalendarOutline size={20} />
              </span>
              <span>{formatDate(webinar.startTime)}</span>
              <span className="ch-separator">|</span>
              <span>{webinar.duration} mins</span>
              <span className="ch-separator">|</span>
              <span>{webinar.joinedUsers?.length || 0} Joined</span>
            </div>
          </div>
        </div>

        <div className="ch-event-actions">
          <div className="ch-actions-left">
            {isAdmin ? (
              <div 
                className="ch-bookings-count"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowUserDetails(true);
                }}
              >
                View Guests
              </div>
            ) : (
              <button
                className={`ch-bookings-count ${isWebinarPast(webinar.startTime) ? 'past' : ''}`}
                onClick={handleWebinarAction}
                disabled={isWebinarPast(webinar.startTime)}
              >
                {isWebinarPast(webinar.startTime) ? (
                  'Webinar Ended'
                ) : webinar.joinedUsers?.some(user => user.email === username) ? (
                  <>
                    <RiVideoAddFill /> Join Webinar
                  </>
                ) : (
                  <>
                    <FaRegCalendarPlus /> Register Now
                  </>
                )}
              </button>
            )}
          </div>

          <div className="ch-actions-right">
            <div className="ch-event-price">
              <div className="ch-price-tag">
                {webinar.price > 0 ? (
                  <>
                    {webinar.discount > 0 && (
                      <span className="ch-original-price">
                        ₹{webinar.price}
                      </span>
                    )}
                    <span className="ch-final-price">
                      ₹{(webinar.price * (1 - webinar.discount / 100)).toFixed(0)}
                    </span>
                  </>
                ) : (
                  <span className="ch-final-price free">Free</span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* User Details Modal */}
      <Modal 
        show={showUserDetails} 
        onHide={() => setShowUserDetails(false)}
        className="user-details-modal-overlay"
        centered
      >
        <Modal.Header closeButton>
          <h3>Registered Users</h3>
        </Modal.Header>
        <Modal.Body>
          <div className="users-list">
            {webinar.joinedUsers?.length > 0 ? (
              webinar.joinedUsers.map((user, index) => (
                <div key={index} className="user-item">
                  <div className="user-avatar">
                    {user.name ? user.name.charAt(0).toUpperCase() : <FaUserCircle />}
                  </div>
                  <div className="user-info">
                    <h4>{user.name}</h4>
                    <div className="user-details">
                      <p><MdEmail />{user.email}</p>
                      <p><MdPhone />{user.mobile}</p>
                      {user.paymentStatus && (
                        <p>
                          <MdPayment />
                          <span className={`payment-status ${user.paymentStatus.toLowerCase()}`}>
                            Payment: {user.paymentStatus}
                            {user.paymentAmount && ` - ₹${user.paymentAmount}`}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-users">
                No users have registered for this webinar yet.
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>

      {/* Webinar Edit Modal */}
      {showAddWebinar && (
        <AddServicePopup
          communityId={communityId}
          onClose={() => setShowAddWebinar(false)}
          onServiceAdded={(editedData) => {
            onUpdate(editedData);
            setShowAddWebinar(false);
          }}
          editingService={{
            ...webinar, 
            type: 'webinar',
            webinarType: 'Private'
          }}
        />
      )}

      {/* Share Popup */}
      {sharePopupOpen && (
        <SharePopup
          postId={webinar._id}
          isOpen={sharePopupOpen}
          setIsOpen={setSharePopupOpen}
          url={socialUrl}
        />
      )}
    </>
  );
};

export default WebinarCard; 